import { FC, InputHTMLAttributes } from 'react';

import { cn } from 'utils/helpers';

export interface PROPS
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  label?: string;
  subText?: string;
  disabled?: boolean;
  onClick?: () => void;
  size?: 'sm' | 'md';
}

const Switch: FC<PROPS> = ({
  checked,
  className,
  label,
  subText,
  disabled,
  onClick,
  size = 'sm',
  ...args
}) => {
  const handleClick = () => {
    if (disabled) return;

    if (onClick) onClick();
  };

  return (
    <div
      className={cn(
        'flex items-center gap-5 cursor-pointer font-normal w-fit',
        className,
      )}
      onClick={handleClick}
    >
      {(label || subText) && (
        <div
          className={cn(
            'flex flex-col gap-1',
            size === 'sm' && 'text-xs',
            size === 'md' && 'text-sm',
          )}
        >
          {label && <h3 className="leading-3">{label}</h3>}
          {subText && <h4 className="text-content leading-5">{subText}</h4>}
        </div>
      )}
      <div className="relative inline-block h-2 w-[26px]">
        <input
          onClick={() => console.log('test')}
          {...args}
          defaultChecked={checked}
          type="checkbox"
          className="absolute h-0 w-0 opacity-0"
          disabled={disabled}
        />
        <div
          className={cn(
            'absolute top-0 left-0 right-0 bottom-0',
            'cursor-pointer rounded-full bg-[#F2F4FE] transition',
          )}
        >
          <div
            className={cn(
              'absolute top-0 h-2 w-[26px] rounded-full transition',
              checked ? 'bg-info-light' : 'bg-secondary-light',
              disabled && '!bg-fill-primary',
            )}
          />
          <div
            className={cn(
              'absolute top-[-3px] h-[14px] w-[14px]',
              'transform rounded-full bg-info-base transition',
              checked ? 'translate-x-[14px]' : 'bg-secondary-base',
              disabled && '!bg-disabled',
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default Switch;
